import { Chip } from '@mui/material';
import { ArrayItemRendererWithCutOff } from 'components/ArrayItemRendererWithCutOff';
import { DataCellProps } from '../types';

const TeamsV2TagsCountCell = ({ team }: DataCellProps) => {
  // De-duplicate tags to ensure unique keys (Set preserves insertion order)
  const tags = Array.from(new Set(team.tags || []));
  if (!tags.length) return null;
  return (
    <ArrayItemRendererWithCutOff<string>
      cutOffLimit={2}
      items={tags}
      renderItem={({ item }) => <Chip label={item} size="small" color="primary" sx={{ mr: 0.5 }} />}
      renderRemainingItems={({ remainingItems }) => (
        <Chip label={`+ ${remainingItems.length}`} size="small" sx={{ mr: 0.5 }} />
      )}
      getKey={(item) => item}
    />
  );
};

export default TeamsV2TagsCountCell;
